import {
  assign, endpoint, options, check, convert,
} from '../../helpers';
import models from './models';

/**
 * Brings the user's saved configuration data from the database
 *
 * @param {Object} props All parameter object used in the process
 * @param {Object=} props.data All data from the interface
 * @param {function=} props.dispatch Redux dispatcher
 * @param {function=} props.error Failed callback function
 * @param {function=} props.success Successful callback function
 */

export default (props) => {
  const state = assign(props);

  fetch(endpoint('/database-configuration'), options())
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        const data = models.response(response.Data);
        state.success(data);
      } else {
        state.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};
